import MyBreadcrumb from "../../components/MyBreadcrumb";
import MySidebar from "../../components/MySidebar";
import { Outlet } from "react-router-dom";

const CommonLayout = () => {
  return (
    <div className="subpage_wrap">
      <div className="width">
        <MySidebar className="left" />
        <div className="right">
          <MyBreadcrumb />

          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
